export const speciesValues = ['human', 'cat', 'dog'];
export const genderValues = ['male', 'female'];
export const productionValues = ['Yes', 'No', 'To review', 'Scratchpad'];
